const subscriptionRenewKeys = {
  // Dialog
  "subscription.renew.dialog.title": "Renovar suscripción",
  "subscription.renew.dialog.description": "Al confirmar esta acción, tu suscripción ya no será cancelada. ¡Gracias por seguir con nosotros!",
  "subscription.renew.dialog.renewal-date": "La suscripción se renovará el {{date}}",
  "subscription.renew.dialog.terms": "Al renovar tu suscripción, aceptas nuestros",
  "subscription.renew.dialog.and": "y",

  // Alternative approach with placeholders
  "subscription.renew.dialog.terms.full": "Al renovar tu suscripción, aceptas nuestros {{termsLink}} y {{privacyLink}}",

  // Actions
  "subscription.renew.action.renew": "Renovar suscripción",

  // Notifications
  "subscription.renew.notification.success.title": "Suscripción renovada",
  "subscription.renew.notification.success.message": "Tu suscripción ha sido renovada con éxito. ¡Gracias por seguir con nosotros!",
  "subscription.renew.notification.error.title": "Error al renovar la suscripción",
  "subscription.renew.notification.error.message": "Ocurrió un error al renovar tu suscripción. Por favor, intenta nuevamente.",
};

export const subscriptionRenew = {
  ...subscriptionRenewKeys,
};
